import React from "react";

const PERSON_IMG =
  "https://cdn3d.iconscout.com/3d/premium/thumb/businessman-holding-laptop-11213816-9052739.png";

export default function HeroCard23() {
  return (
    <>
      <section className="hr-hero">
        {/* BACKGROUND DECOR */}
        <div className="hr-arch"></div>

        {/* LEFT CONTENT */}
        <div className="hr-left">
          <h1 className="hr-title">
            Find a Perfect <br /> Candidate
          </h1>

          <p className="hr-subtitle">
            Find Jobs, Employment & Career Opportunities
          </p>

          <button className="hr-btn">Search Job</button>
        </div>

        {/* RIGHT SIDE PERSON + FLOATING CARDS */}
        <div className="hr-right">
          <img src={PERSON_IMG} alt="illustration" className="hr-person" />

          {/* Upload CV card */}
          <div className="hr-card cv-card">
            <div className="hr-card-icon">📄</div>
            <div>
              <strong>Upload Your CV</strong>
              <p>It only takes a few seconds</p>
            </div>
          </div>

          {/* Candidates card */}
          <div className="hr-card candidates-card">
            <strong>12k+ Candidates</strong>
            <div className="hr-avatars">
              <div className="av"></div>
              <div className="av"></div>
              <div className="av"></div>
            </div>
          </div>

          {/* Video card */}
          <div className="hr-card video-card">
            <div className="hr-card-icon">🎥</div>
            <div>
              <strong>Our Video</strong>
              <p>Lorem ipsum dolor sit.</p>
            </div>
          </div>
        </div>

        {/* Scroll to Top Button */}
        <button className="hr-up-btn">↑</button>
      </section>

      <style>{`
/* MAIN HERO WRAPPER */
.hr-hero {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 80px 6%;
  background: #e8edff;
  min-height: 85vh;
  overflow: hidden;
}

/* LEFT SIDE */
.hr-left {
  width: 48%;
  padding-top: 40px;
}

.hr-title {
  font-size: 3.8rem;
  font-weight: 900;
  color: #000;
  line-height: 1.1;
}

.hr-subtitle {
  margin-top: 20px;
  color: #576178;
  font-size: 1.2rem;
}

.hr-btn {
  margin-top: 30px;
  background: #1e255b;
  color: #fff;
  padding: 14px 30px;
  font-size: 1.1rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 600;
}

/* RIGHT SIDE */
.hr-right {
  width: 48%;
  position: relative;
}

.hr-person {
  width: 420px;
  position: relative;
  z-index: 3;
}

/* DARK BLUE ARCH BEHIND PERSON */
.hr-arch {
  position: absolute;
  right: 12%;
  top: 12%;
  width: 340px;
  height: 480px;
  background: #1e255b;
  border-radius: 180px 180px 0 0;
  z-index: 1;
}

/* FLOATING CARDS (CSS NO JS) */
.hr-card {
  position: absolute;
  background: white;
  padding: 18px 20px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.08);
  animation: float 4s ease-in-out infinite;
  font-size: 0.85rem;
}

.hr-card strong {
  font-size: 0.92rem;
  display: block;
  margin-bottom: 2px;
}

.hr-card p {
  margin: 0;
  opacity: 0.6;
  font-size: 0.8rem;
}

@keyframes float {
  0% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
  100% { transform: translateY(0); }
}

/* Card positions */
.cv-card {
  top: 60px;
  right: 80px;
  z-index: 4;
}

.candidates-card {
  top: 120px;
  right: -10px;
  padding: 14px 20px;
}

.video-card {
  bottom: 40px;
  right: 120px;
}

/* ICONS IN CARD */
.hr-card-icon {
  width: 38px;
  height: 38px;
  background: #f0f3ff;
  display: grid;
  place-items: center;
  border-radius: 8px;
  font-size: 1.2rem;
  margin-bottom: 6px;
}

/* FAKE AVATARS */
.hr-avatars {
  display: flex;
  gap: 6px;
  margin-top: 6px;
}
.av {
  width: 24px;
  height: 24px;
  background: #d0d4f0;
  border-radius: 50%;
}

/* UP ARROW BUTTON */
.hr-up-btn {
  position: absolute;
  right: 30px;
  bottom: 30px;
  background: #1e255b;
  color: #fff;
  border: none;
  width: 48px;
  height: 48px;
  font-size: 1.3rem;
  border-radius: 10px;
  cursor: pointer;
}

/* RESPONSIVE */
@media (max-width: 950px) {
  .hr-hero {
    flex-direction: column;
    text-align: center;
    padding-top: 40px;
  }

  .hr-left, .hr-right {
    width: 100%;
  }

  .hr-arch {
    display: none;
  }

  .hr-person {
    margin: 0 auto;
  }

  .hr-card {
    position: relative;
    display: inline-block;
    margin: 10px auto;
    animation: none;
  }

  .hr-up-btn {
    right: 20px;
  }
}
      `}</style>
    </>
  );
}
